import axios from 'axios'
import { captureException } from '@sentry/browser'

const cAxios = axios.create({
  baseURL: '/web-api',
  headers: {
    'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content'),
    'X-Requested-With': 'XMLHttpRequest',
  },
})

// Add a response interceptor
cAxios.interceptors.response.use(
  (response) =>
    // Do something with response data
    response,
  (error) => {
    // Here we send the error, but we should also handle it so the user knows something went wrong
    captureException(error)
    return Promise.reject(error)
  },
)

export default cAxios
